import React from 'react';
import { getImage } from 'gatsby-plugin-image';
import { convertToBgImage } from 'gbimage-bridge';
import { getImageId } from '@gynzy/gatsby-source-storyblok';
import BackgroundImage from 'gatsby-background-image';

function BackgroundImageWrapper({ backgroundImage, pageContext, children, style }) {
	if (backgroundImage?.filename) {
		const imageId = getImageId(backgroundImage.filename);
		const imageData = pageContext.images?.find(img => img.id === imageId);

		if (imageData && imageData.localFile) {
			const image = getImage(imageData.localFile);

			if (image) {
				return (
					<BackgroundImage {...convertToBgImage(image)} style={style}>
						{children}
					</BackgroundImage>
				);
			}

			return <div style={{ backgroundImage: `url(${imageData.localFile.publicURL})`, ...style }}>{children}</div>;
		}

		return <div style={{ backgroundImage: `url(${backgroundImage.filename})`, ...style }}>{children}</div>;
	}

	return children;
}

export default BackgroundImageWrapper;
